import React from 'react';
import { useHistory } from 'react-router-dom';
import IconButton from '../../../../../muiComponents/IconButton';
import Button from '../../../../../muiComponents/Button';
import useTheme from '../../../../../customHooks/useTheme';
import useTranslate from '../../../../../customHooks/useTranslate';
import { ThemeTypes } from '../../../../../types/theme/themeTypes';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';
import { useZitoneoUI } from '../../../contexts/ZitoneoUIContext';
import {
    useZitoneoContent,
    useZitoneoServices,
} from '../../../contexts/ZitoneoContentContext';
import { ZitoneoViewMode } from '../../../types/zitoneoServicesTypes';
import { getHotelQuickAccessItems } from '../../../utils/hotelPresentationUtils';
import ServicesViewModeSelector from './ServicesViewModeSelector';
import PreviewModeSelector from './PreviewModeSelector';
import ExportExcelReport from './ExportExcelReport';
import Activity from '../../../../../layout/header/activity/Activity';

interface HeaderActionsProps {
    isInDetail: boolean;
    isHotelPresentation: boolean;
    isEditor: boolean;
    isPreview: boolean;
    isSettings: boolean;
}

const HeaderActions = ({
    isInDetail,
    isHotelPresentation,
    isEditor,
    isPreview,
    isSettings,
}: HeaderActionsProps) => {
    const translate = useTranslate();
    const history = useHistory();
    const { theme, setTheme } = useTheme();
    const isDark = theme === ThemeTypes.DARK;
    const { isLoading } = useZitoneoUI();
    const { saveHotelContent, changeViewMode } = useZitoneoServices();
    const { hotelContent } = useZitoneoContent();
    const quickAccessItems = hotelContent.Id
        ? getHotelQuickAccessItems(
              hotelContent.Id,
              hotelContent.HotelRoomTypes?.[0]?.Id
          ).filter(item => item.headerLabel)
        : [];

    return (
        <div className='zitoneo-header__actions zitoneo-header__inert'>
            <div className='zitoneo-header__view-controls'>
                {isInDetail && !isSettings && <ServicesViewModeSelector />}
                {isPreview && <PreviewModeSelector />}
            </div>
            {isInDetail && (
                <>
                    <IconButton
                        iconName={
                            isSettings ? commonIcons.EDIT : 'SettingsOutlined'
                        }
                        disabled={isLoading}
                        onClick={() =>
                            changeViewMode(
                                isSettings
                                    ? ZitoneoViewMode.EDITOR
                                    : ZitoneoViewMode.SETTINGS
                            )
                        }
                    />
                    <Button
                        onClick={() => saveHotelContent()}
                        variant='contained'
                        disabled={isLoading}
                        startIcon='SaveOutlined'
                    >
                        {translate('save')}
                    </Button>
                </>
            )}
            <div className='zitoneo-header__secondary-actions'>
                {isHotelPresentation &&
                    quickAccessItems.map(item => (
                        <Button
                            key={item.label}
                            variant='outlined'
                            color='secondary'
                            size='small'
                            startIcon={item.icon}
                            disabled={isLoading}
                            onClick={() => history.push(item.route)}
                        >
                            {translate(item.headerLabel)}
                        </Button>
                    ))}
                {isEditor && <ExportExcelReport isLoading={isLoading} />}
                <Activity />
                <IconButton
                    iconName={
                        isDark ? 'LightModeOutlined' : 'ModeNightOutlined'
                    }
                    disabled={isLoading}
                    onClick={() =>
                        setTheme(isDark ? ThemeTypes.LIGHT : ThemeTypes.DARK)
                    }
                />
            </div>
        </div>
    );
};

export default HeaderActions;
